import React from "react";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";
import { CheckboxGroup } from "../CheckboxGroup";

type InputProps = Omit<
  React.ComponentProps<typeof CheckboxGroup>,
  "name" | "value" | "onChange"
>;

interface FormCheckboxGroupProps<TFieldValues extends FieldValues>
  extends InputProps {
  name: UseControllerProps<TFieldValues>["name"];
  control: UseControllerProps<TFieldValues>["control"];
}

const FormCheckboxGroup = <TFieldValues extends FieldValues>({
  name,
  control,
  ...rest
}: FormCheckboxGroupProps<TFieldValues>) => {
  const { field, fieldState } = useController({
    name,
    control,
  });

  return (
    <CheckboxGroup {...rest} {...field} error={fieldState.error?.message} />
  );
};

export { FormCheckboxGroup };
